import _ from 'lodash'
import i18n from '../i18n/i18n'

import { firebaseAuth as auth, firebaseDb as db } from '../firebase'
import { Method, cloudFunctionRequest } from '../cloudFunction'
import { fetchProjects, fetchCompanies, asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../actions'

// action types
export const STORE_USER_DATA = 'STORE_USER_DATA'
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA'
export const UPDATE_USER_CLAIMS = 'UPDATE_USER_CLAIMS'
export const STORE_PROJECTS_ROLES = 'STORE_PROJECTS_ROLES'
export const STORE_IS_SUPER_ADMIN = 'STORE_IS_SUPER_ADMIN'
export const STORE_USER_SETTINGS = 'STORE_USER_SETTINGS'
export const STORE_COMPANIES_ROLES = 'STORE_COMPANIES_ROLES'

// action creators
export const verifyAuth = () => {
  console.log('verifyAuth')
  // https://tighten.co/blog/react-101-part-4-firebase/
  return dispatch =>
    auth.onAuthStateChanged(user => {
      if (user) {
        user
          .getIdToken()
          .then(idToken => {
            dispatch(storeUserData(user, idToken))
            dispatch(storeIsSuperAdmin(user.uid)) // we are calling 'fetchProjects' + 'fetchCompanies' there
            dispatch(storeUserSettings(user.uid))
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        dispatch(clearUserData())
      }
    })
}

export const storeUserData = (user, idToken) => {
  return {
    type: STORE_USER_DATA,
    payload: { user, idToken }
  }
}

export const storeIsSuperAdmin = userId => {
  return dispatch => {
    db
      .collection('settings')
      .doc('security')
      .get()
      .then(doc => {
        if (doc.exists) {
          dispatch({
            type: STORE_IS_SUPER_ADMIN,
            payload: { isSuperAdmin: true }
          })
        }
        dispatch(fetchProjects(userId, true)) // 2nd param = 'isSuperAdmin'
        dispatch(fetchCompanies(userId, true))
      })
      .catch(() => {
        dispatch(fetchProjects(userId, false))
        dispatch(fetchCompanies(userId, false))
      }) // do not remove - otherwise error on console
  }
}

export const storeUserSettings = userId => {
  return dispatch => {
    db
      .collection('users')
      .doc(userId)
      .get()
      .then(doc => {
        if (doc.exists) {
          // if language is defined update language (view will reload)
          doc.data().lang && i18n.changeLanguage(doc.data().lang)

          dispatch({
            type: STORE_USER_SETTINGS,
            payload: { settings: doc.data() }
          })
        }
      })
      .catch(() => {})
  }
}

export const updateUserSettings = userSettings => {
  return dispatch => {
    dispatch(asyncRequest('updateUserSettings'))

    db
      .collection('users')
      .doc(userSettings.uid)
      .update(userSettings)
      .then(() => {
        dispatch(asyncSuccess('updateUserSettings', { userSettings }, 'Settings updated successfully'))
        dispatch(cleanMessages())
        i18n.changeLanguage(userSettings.lang)
        // TODO: Distribute name change everywhere in DB where the name was used
      })
      .catch(error => {
        dispatch(asyncFail('updateUserSettings', error))
        dispatch(cleanMessages())
      })
  }
}

export const clearUserData = () => {
  return {
    // TODO: Clear also projects
    type: CLEAR_USER_DATA
  }
}

export const updateUserClaims = idToken => {
  return {
    type: UPDATE_USER_CLAIMS,
    payload: { idToken }
  }
}

export const addUser = (userData, userToken, resetFormFields) => {
  return dispatch => {
    dispatch(asyncRequest('addUser'))

    const postData = {
      userToken, // 'creator' userToken
      name: userData.name,
      email: userData.email,
      projects: [],
      companies: []
    }

    _.map(userData.companies, (role, companyId) => {
      postData.companies.push({
        companyId,
        role
      })
    })

    _.map(userData.projects, (role, projectId) => {
      postData.projects.push({
        projectId,
        role
      })
    })

    cloudFunctionRequest('auth/createUser', Method.POST, postData)
      .then(response => {
        dispatch(asyncSuccess('addUser', { postData, userId: response.data.data.userId }, response.data.message))
        dispatch(cleanMessages())
        resetFormFields()
      })
      .catch(error => {
        console.log('auth/createUser error')
        console.log(error)
        dispatch(asyncFail('addUser', error.data && error.data.message)) // TODO: show message based on code
        dispatch(cleanMessages())
      })
  }
}

export const storeProjectsRoles = projectsRoles => {
  return {
    type: STORE_PROJECTS_ROLES,
    payload: { projectsRoles }
  }
}

export const storeCompaniesRoles = companiesRoles => {
  return {
    type: STORE_COMPANIES_ROLES,
    payload: { companiesRoles }
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js